/* eslint-disable */
import urlJoin from 'url-join';
export function makeCooperativeCompaniesUrl(boBaseUrl) {
    const boServerUrl = boBaseUrl + '/backoffice';
    const J = path => urlJoin(boServerUrl, path);
    return {
        getCooperativeCompanyList: J('/cooperative-companies'),
        getCooperativeCompany: J('/cooperative-companies/${cooperative_company_id}'),
        postEditCooperativeCompany: J('/cooperative-companies/${cooperative_company_id}'),
        postBatchEditCooperativeCompanies: J('/cooperative-companies/batch-edit'),
        postBatchAddCooperativeCompanies: J('/cooperative-companies/batch-add'),
        getCompaniesSolr: J('/companies/solr'),
    };
}
